import { db } from "../../firebase";
import Vue from "vue";

const state = {
  selvyData: {},
  status: "",
  diagnosisDate: "" // ToDo 診断日については要検討!!
};
const mutations = {
  fetchSelvy(state, payload) {
    state.selvyData = payload;
    state.status = "fetch";
  },
  setSelvy(state, date, payload) {
    Vue.set(state.selvyData, date, payload);
    state.diagnosisDate = date;
    state.status = "set";
  },
  deleteSelvy(state, date) {
    Vue.Delete(state.selvyData, date);
    state.status = "delete";
  },
  clear(state) {
    state.selvyData = {};
    state.diagnosisDate = "";
    state.status = "";
  },
  setDiagnosisDate(state, date) {
    state.diagnosisDate = date;
  }
};
const actions = {
  fetchSelvy({ commit }, payload) {
    commit("fetchSelvy", payload);
  },
  setSelvy({ commit }, date, payload) {
    commit("setSelvy", date, payload);
  },
  deleteSelvy({ commit }, date, payload) {
    commit("deleteSelvy", date, payload);
  },
  setDiagnosisDate({ commit }, payload) {
    commit("setDiagnosisDate", payload.date);
  },
  // Firebaseから全てのからだ手帳データを取得
  async fetchSelvyFromFirebase({ commit }, uid) {
    try {
      const snapshot = await db.ref(`/selvy/${uid}`).once("value");
      if (snapshot.val()) {
        commit("fetchSelvy", snapshot.val());
      } else {
        commit("fetchSelvy", {});
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseに指定した日付のからだ手帳データを新規登録、上書き
  async sendSelvyToFirebase({ dispatch, commit, state }, uid, date, selvyData) {
    // 指定した日付のデータが存在する場合
    if (state.selvyData.find(v => v.key === date)) {
      // 日付が存在する場合はアップデート
      dispatch("updateSelvyToFirebase", {
        uid: uid,
        date: date,
        payload: selvyData
      });
    } else {
      try {
        await db.ref(`/selvy/${uid}/${date}`).set(selvyData);
        commit("setSelvy", date, selvyData);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error.message);
      }
    }
  },
  // Firebaseに指定した日付のからだ手帳データをアップデート
  async updateSelvyToFirebase({ commit }, uid, date, selvyData) {
    try {
      await db.ref(`/selvy/${uid}/${date}`).update(selvyData);
      commit("setSelvy", date, selvyData);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  },
  // Firebaseに指定した日付のからだ手帳データを削除
  async deleteSelvyToFirebase({ commit }, uid, date) {
    try {
      await db.ref(`/selvy/${uid}/${date}`).update(null);
      commit("deleteSelvy", date);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error.message);
    }
  }
};
const getters = {
  getDiagnosisDate: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.diagnosisDate;
    } else {
      return "";
    }
  },
  getHealthAge: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].healthAge.age;
    } else {
      return 0;
    }
  },
  getRealAge: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].parameter.features[0].GENERAL
        .AGE;
    } else {
      return 0;
    }
  },
  genderCode: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].parameter.features[0].GENERAL
        .SEX;
    } else {
      return 0;
    }
  },
  getName: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].name;
    } else {
      return 0;
    }
  },
  getDeathScore: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].death.score;
    } else {
      return 0;
    }
  },
  getDeathStatistics: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].death.statistics;
    } else {
      return 0;
    }
  },
  getDiseaseRisks: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].diseaseRisks;
    } else {
      return [];
    }
  },
  getRiskFactors: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].factors;
    } else {
      return [];
    }
  },
  getParameter: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].parameter;
    } else {
      return [];
    }
  },
  getGroupAnarysis: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].groupAnalysis;
    } else {
      return [];
    }
  },
  getModel: state => {
    if (state.selvyData && state.diagnosisDate) {
      return state.selvyData[state.diagnosisDate].parameter.model;
    } else {
      {
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
